import { type TValidationConfig } from '../types/configs';

import { getObjectValidation, getStringValidation } from './validations';

function getNamesAndPartiesSchema(validationConfig: TValidationConfig) {
  return {
    declarantCode: getStringValidation({ field: 'declarantCode', validationConfig }),
    declarantName: getStringValidation({ field: 'declarantName', validationConfig }),
    companyCode: getObjectValidation({ field: 'companyCode' }),
    companyPhone: getStringValidation({ field: 'companyPhone', validationConfig }),
    companyEmail: getStringValidation({ field: 'companyEmail', email: true, validationConfig }),
    exporterNameAndAddress: getStringValidation({ field: 'exporterNameAndAddress', validationConfig }),
  };
}

export default getNamesAndPartiesSchema;
